import { WithStyles } from 'decorators/withStyles';
import * as React from 'react';
import storageService from 'services/storage';
import { enabledIcon, localStorageNewsName, messageNewsIcon, onlyUnity } from 'data/featureRelease';
import TooltipHelp from '../../Tooltip/index';
import AlertCircle from 'mdi-react/AlertCircleIcon';
import authService from 'services/auth';
interface IProps {
  classes?: any;
  hideIcon: boolean;
}

interface IState {
  open: boolean;
  isClubeBlack: boolean;
}

@WithStyles({
  iconTooltip: {
    fill: '#4CAF50'
  }
})
export default class AnnouncementIcon extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { open: true, isClubeBlack: false };
  }

  componentDidMount() {
    authService.isClubeBlack().subscribe(isClubeBlack => {
      this.setState({ isClubeBlack });
    });

    storageService.get(`${localStorageNewsName}-icon`).subscribe(newsWpp => {
      this.setState({ open: !newsWpp });
      if (newsWpp) {
        this.hideIcon();
      }
    });
  }

  hideIcon = () => {
    storageService.set(`${localStorageNewsName}-icon`, true).subscribe();
    this.setState({ open: false });
  };

  render() {
    if (!enabledIcon) {
      return null;
    }
    const { classes, hideIcon } = this.props;
    const { open } = this.state;

    if (hideIcon) {
      this.hideIcon();
    }

    if (!open || hideIcon || (onlyUnity && !this.state.isClubeBlack)) {
      return null;
    }

    return (
      <span>
        <TooltipHelp open={open} title={messageNewsIcon}>
          <AlertCircle size={18} className={classes.iconTooltip} />
        </TooltipHelp>
      </span>
    );
  }
}
